module.exports = __webpack_public_path__ + "img/text-header-icantech.8c0624d5.png";